const bannerSlotsApi = require('../api/bannerSlots');

const MIN_BANNER_SLOTS_UPDATE = 1000 * 60 * 7;
const FETCH_BANNER_SLOTS_TIMEOUT = 1000 * 30;

function fetchBannerSlotsInProgress() {
  return {
    type: 'FETCH_BANNER_SLOTS_IN_PROGRESS',
    timestamp: Date.now(),
  };
}

function fetchBannerSlotsSuccessful(bannerSlots) {
  return {
    type: 'FETCH_BANNER_SLOTS_SUCCESSFUL',
    bannerSlots,
    timestamp: Date.now(),
  };
}

function fetchBannerSlotsFailed(reason) {
  return {
    type: 'FETCH_BANNER_SLOTS_FAILED',
    reason,
    timestamp: Date.now(),
  };
}

function fetchBannerSlots(platform) {
  return (dispatch, getState) => {
    dispatch(fetchBannerSlotsInProgress());

    const state = getState();
    const { country, apiUrl } = state.auth;

    return bannerSlotsApi
      .fetchBannerSlots(apiUrl, country.value, platform)
      .then(
        (bannerSlots) => {
          dispatch(fetchBannerSlotsSuccessful(bannerSlots));
          return bannerSlots;
        },
        (error) => {
          dispatch(fetchBannerSlotsFailed(error));
          throw error;
        },
      );
  };
}

function shouldFetchBannerSlots(state) {
  const { didInvalidate, fetchingInProgressSince, lastSuccessfulFetch } =
    state.bannerSlots;

  if (!fetchingInProgressSince) {
    if (didInvalidate) {
      return true;
    }

    if (
      !lastSuccessfulFetch ||
      Date.now() - lastSuccessfulFetch > MIN_BANNER_SLOTS_UPDATE
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_BANNER_SLOTS_TIMEOUT
  ) {
    return true;
  }

  return false;
}

function fetchBannerSlotsIfNeeded(platform) {
  return (dispatch, getState) => {
    if (shouldFetchBannerSlots(getState())) {
      return dispatch(fetchBannerSlots(platform));
    }
    return Promise.resolve();
  };
}

module.exports = {
  fetchBannerSlots,
  fetchBannerSlotsIfNeeded,
};
